import { render } from "./Credithours.vue?vue&type=template&id=3f0734e8&scoped=true"
import script from "./Credithours.vue?vue&type=script&lang=js"
export * from "./Credithours.vue?vue&type=script&lang=js"

import "./Credithours.vue?vue&type=style&index=0&id=3f0734e8&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0734e8"]])

export default __exports__